import React, { Fragment } from 'react';
import {Button} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';
import Alerta from '../../layout/alert/Alerta';
import Preload from '../../layout/preload/Preload';

import TypeFieldEnum from './TypeFieldEnum';

import ConfiguracaoService from '../../../service/ConfiguracaoService';

class ModalOpcao extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            erro: {
                message: '',
                code: 0
            },

            preload: false
        }
    }

    onSubmit() {
        this.setState({preload: true});

        ConfiguracaoService.gravar(
            this.props.item.uuid,
            this.props.valor
        ).then(() => {
            this.props.onRefresh();
            this.setState({preload: false});
        }).catch(error => {
            this.setState({
                erro: this.trataErro(error),
                preload: false
            });            
        });
    }   

    show() {
        if(!this.props.show)
            return ;

        return (
            <div 
                className={"modal " + this.props.className} 
                tabIndex="-1" 
                role="dialog" 
                style={{display: 'block'}}
            >
                <Preload show={this.state.preload} />

                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {
                            this.props.header !== "" &&
                            <div className="modal-header bg-white">
                                <div className="col-md-10                                 
                                                col-sm-10                                                
                                                col-lg-10                                                
                                                col-xs-10"> 
                                    <h4>
                                        {this.props.header}
                                    </h4>
                                </div>

                                <div className="col-md-2                                 
                                                col-sm-2                                                
                                                col-lg-2                                                
                                                col-xs-2"> 
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.props.fechar()}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        }

                        <div className="modal-body">
                            <div                                 
                                style={{
                                    wordWrap: 'break-word', 
                                    marginBottom: '15px'
                                }}>

                                <Alerta
                                    exibir={this.state.erro.code !== 0}
                                    texto={this.state.erro.message}
                                    timeOut={5}

                                    onTimeOut={() => this.setState({erro: this.trataErro(this.state.erro)})}
                                />

                                { 
                                    TypeFieldEnum.get(this.props.item.type).component(
                                        this, 
                                        this.props.item.chave,
                                        this.props.valor, 
                                        this.props.item.enum_value
                                    ) 
                                }
                            </div>
                        </div>

                        <div className="modal-footer">
                            <Button 
                                className="btn btn-primary"  
                                type="button" 
                                onClick={() => {this.onSubmit()}}
                            >
                                Salvar
                            </Button>

                            <Button 
                                className="btn btn-danger"  
                                type="button" 
                                onClick={() => {this.props.fechar()}}
                            >
                                Fechar
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <Fragment>
                {this.show()}            
            </Fragment>
        )
    }
}

ModalOpcao.defaultProps = {
    
}

export default ModalOpcao;